export default (initialValue) => {
  let oldValue = initialValue;
  const callbacks = [];

  const registerCallback = (callback) => {
    callbacks.push(callback);
  }

  const comparator = (newValue) => {
    if (oldValue !== newValue) {
      oldValue = newValue;
      callbacks.forEach(callback => {callback(newValue)})
    }
  }

  return {
    comparator,
    registerCallback
  }
};



// WEBPACK FOOTER //
// ./utils/makeValueChangeSpy.js